export default "__VITE_ASSET__F_146YM2__"